'use strict'

const TransformStream = require('readable-stream').Transform
const pingMessageConverter = require('./ping-message-converter')

class PingMessageStream extends TransformStream {
  constructor (options) {
    const opts = Object.assign(options || {}, { objectMode: true })
    super(opts)
  }

  _transform (obj, enc, callback) {
    try {
      const msg = pingMessageConverter(obj)
      this.push(msg)

      if (!msg.success) {
        throw new Error(msg.text)
      }
    } catch (err) {
      return callback(err)
    }
    callback()
  }
}

module.exports = PingMessageStream



//////////////////
// WEBPACK FOOTER
// ./src/utils/ping-message-stream.js
// module id = 104
// module chunks = 0